import VueCookies from 'vue-cookies';
import googleAnalyticsService from './googleAnalyticsService';
import pendoService from './pendoService';
import internalDb from './internalDb';

export const userInfo = () => {
  const jwt = VueCookies.get('token');
  const splitJWT = jwt?.split('.');
  const jwtData = splitJWT?.[1];
  if (!jwtData) { return {}; }
  return JSON.parse(atob(jwtData));
};

export const trackerService = async ({ event, payload }, route, debug = false, eventsRegisteredId = null) => {
  if (debug) {
    console.log(`DEBUG TRACKER: ${event}`, payload, route, userInfo());
    return;
  }
  const data = {
    ...payload,
    page_source: route.name,
    page_url: route.path,
    platform: 'web',
    events_registered: eventsRegisteredId,
    timestamp: new Date().toISOString(),
  };

  googleAnalyticsService.sendEvent(event, { ...userInfo(), ...data });
  pendoService.sendEvent(event, data);
  await internalDb.sendEvent(event, { ...userInfo(), ...data });
};

export const startTrackerService = () => {
  googleAnalyticsService.init(userInfo());
  pendoService.init(userInfo());
  internalDb.init(userInfo());
};

export const identifyUser = () => {
  // For now only GA needs this step
  const user = userInfo();
  if (Object.keys(user).length) {
    googleAnalyticsService.identify(user);
  }
};

export default {
  trackerService,
  startTrackerService,
  identifyUser,
};
